// extracted by mini-css-extract-plugin
export default {"root":"BrandBanner_root__X0zta","mainContainer":"BrandBanner_mainContainer__jmwbW","pageTitle":"BrandBanner_pageTitle__X86qR","pageTitleSpan":"BrandBanner_pageTitleSpan__S+upl"};